import * as moment from 'vendors/moment-locale-th';

import { CancellationPolicy, ProductRoomDetailModel, RoomConditionDto, RoomDetailDto, Room } from '../../model/products/product-room-detail.model';
import { Response, URLSearchParams } from '@angular/http';

import { AppConfigService } from '../app-config/app-config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ProductDetailInfoModel, DisplayLabel, ProductDisplayLabel } from '../../model/products/product-detail-info.model';
import { ProductDetailModel, GetProductDetailWithUrlModel, BadgeModel, ShaModel } from '../../model/products/product-detail.model';
import { ProductDetailPayload } from './payload/product-detail.payload';
import { ProductOptionDetailPayload } from './payload/product-option-detail.payload';
import { ProductRoomDetailPayload } from './payload/product-room-detail.payload';
import { SearchFormModel } from 'app/model/search-form-model';
import { Subject } from 'rxjs/Subject';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { UserModel } from '../../model/user.model';
import { UtilitiesService } from '../utilities/utilities.service';
import { environment } from '../../../environments/environment';
import { ActHttpService, HeaderTypes, ContentTypes } from '../act-http/act-http.service';
import { DefaultValue, Language, PurposeType } from '../../model/constant';
import { ProductNearByPayload, PriceRange } from './payload/product-nearby-payload';
import { ProductNearByModel } from 'app/model/products/product-nearby.model';
import { ProductListModel } from 'app/model/products/product-list.model';
import { ProductNearByDTO } from 'app/model/products/product-nearby-dto.model';
import { GuestModel, DestinationModel } from 'app/model/search-form-model';
import { FeatureType } from 'app/model/constant';
import { ProductReviewList } from 'app/model/products/product-review-list.model';
import { HotelListRequest, HotelListResponse, CheapestRoom, HotelListPriceRangeResponse } from 'app/model/products/hotel/hotel.model';
import { ProductReviewModel } from 'app/model/products/product-review.model';
import { CurrencyService } from '../currency/currency.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { redirectURIV2, useHotelDetailV2 } from 'environments/properties';
@Injectable()
export class ProductService {

  readonly maxAllotment = 9;

  public detail$ = new Subject<ProductDetailInfoModel>();
  public roomDetail$ = new Subject<RoomDetailDto>();

  constructor(
    private actHttp: ActHttpService,
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService,
    private translate: TranslatePipe,
    private utilities: UtilitiesService,
    private currencyService: CurrencyService,
    private authService: AuthenticationService,
  ) { }

  getProductList(payload): Observable<any> {
    return this.actHttp.post(
      environment.endpoint.getProductList,
      payload,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json());
  }

  getTopHotelList(request: HotelListRequest): Observable<HotelListResponse> {
    const url = `${environment.endpoint.getTopHoteList}`;
    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getHotelList(request: HotelListRequest): Observable<HotelListResponse> {
    const url = `${environment.endpoint.getHotelList}`;
    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getAdsHotelByDestination(request: HotelListRequest): Observable<HotelListResponse> {
    const url = environment.endpoint.getAdsHotelByDestination;
    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getAdsHotelByPOI(request: HotelListRequest): Observable<HotelListResponse> {
    const url = environment.endpoint.getAdsHotelByPOI;
    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getProductListWithPOI(request: HotelListRequest): Observable<HotelListResponse> {
    const url = environment.endpoint.getProductListWithPOIV3;
    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getProductDetail(productId: string): Observable<ProductDetailModel> {
    return this.actHttp.post(
      environment.endpoint.getProductDetail,
      new ProductDetailPayload(productId, this.appConfigService.getLanguageId()),
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getHotelPriceRange(request: HotelListRequest): Observable<HotelListPriceRangeResponse> {
    const url = `${environment.endpoint.getHotelList}/info`;
    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getHotelPriceRangePOI(request: HotelListRequest): Observable<HotelListPriceRangeResponse> {
    const url = `${environment.endpoint.getHotelList}/poi/info`;
    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getProductRoomDetail(productRoomDetail: ProductRoomDetailPayload): Observable<ProductRoomDetailModel> {
    // Remove children from request before search
    // TODO: Please remove this logic after fixing the problem about booking with children
    productRoomDetail.rooms = productRoomDetail.rooms.map((room: GuestModel) => new GuestModel(room.adult, []));

    return this.actHttp.post(environment.endpoint.getProductRoomDetail,
      productRoomDetail,
      this.actHttp.getRequestOptions()
    ).map((response: Response) => {
      return response.json().data;
    });
  }

  getProductOptionDetails(payload: ProductOptionDetailPayload) {
    payload.langId = +this.appConfigService.getLanguageId();
    return this.actHttp.post(
      environment.endpoint.getProductOptionDetail,
      payload,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res.json().data);
  }

  getHotelReviewList(hotelId: string, page: number, pageSize: number, sort: string, sortDir: string): Observable<ProductReviewList> {
    const url = environment.endpoint.getHotelReviewList.replace('{hotelId}', hotelId) +
      `?page=${page}&pageSize=${pageSize}&sort=${sort}&sortDir=${sortDir}`;

    return this.actHttp.get(url,
      this.actHttp.getRequestOptions()).map((response: Response) => {
        return response.json().data;
      });
  }

  broadcastDetail(data: ProductDetailInfoModel) {
    this.detail$.next(data);
  }

  broadcastRoomDetail(data: RoomDetailDto) {
    this.roomDetail$.next(data);

  }

  formatTitleProductDetail(productDetail: ProductDetailModel): ProductDetailModel {
    if (productDetail && productDetail.details) {
      productDetail.details.address = this.formatDisplayTitle(productDetail.details.address);
      productDetail.details.countryTitle = this.formatDisplayTitle(productDetail.details.countryTitle);
      productDetail.details.destinationTitle = this.formatDisplayTitle(productDetail.details.destinationTitle);
      if (productDetail.details.reviewRating) {
        productDetail.details.reviewRating.totalTitle = this.calculateReviewRatingTitle(+productDetail.details.reviewRating.totalScore!);
      }
    }
    return productDetail;
  }


  transformProductRoomDetailsToRoomConditions(
    productRooms: Room[],
    searchForm: SearchFormModel,
    currentUser: UserModel,
    travelPolicyBudget: number,
    isShareBudget: boolean,
    isAllowBookForTraveller: boolean,
    crossCondition: boolean): RoomConditionDto[] {
    let index = 0;
    const count = [];
    const round = [];
    for (let i = 0; i < productRooms.length; i++) {
      count.push(productRooms[i].conditions.length);
      round.push(productRooms[i].conditions.length);
    }
    const allowMultiPayment = this.allowMultiPayment(currentUser, isShareBudget);

    const roomConditionResult: RoomConditionDto[] = productRooms.map(
      optionDetail => optionDetail.conditions.map(
        conditionDetail => {
          const roomCondition = new RoomConditionDto();
          roomCondition.lineItemId = conditionDetail.lineItemId;
          roomCondition.allotment = this.calculateAllotment(optionDetail.allotment, searchForm, currentUser);
          roomCondition.roomCode = optionDetail.roomCode;
          roomCondition.roomSize = productRooms[index].roomSize;
          roomCondition.roomView = productRooms[index].roomView;
          roomCondition.numberOfBedroom = productRooms[index].numberOfBedroom;
          roomCondition.numberOfBathroom = productRooms[index].numberOfBathroom;
          roomCondition.sharedBathroom = productRooms[index].sharedBathroom;
          roomCondition.bedType = productRooms[index].bedType;

          roomCondition.isFirstCondition = count[index] === 1 ? true : round[index] === count[index] ? true : false;
          roomCondition.isCountRow = count[index];
          round[index] = --round[index];
          round[index] === 0 ? index++ : index;

          roomCondition.image = optionDetail.image ? optionDetail.image : this.appConfigService.defaultProductImage;
          roomCondition.title = optionDetail.title;
          roomCondition.displayTitle = this.formatDisplayTitle(optionDetail.title);

          roomCondition.adult = conditionDetail.adult;
          roomCondition.breakfast = conditionDetail.breakfast;
          roomCondition.offerTypeName = conditionDetail.offerTypeName;
          roomCondition.offerTypeDisplay = conditionDetail.offerTypeDisplay;
          roomCondition.child = conditionDetail.child;
          roomCondition.netPrice = conditionDetail.netPrice;
          roomCondition.cancellationPolicies = conditionDetail.cancellationPolicies;
          roomCondition.averageNetPrice = this.calculateCurrency(conditionDetail.netPrice);
          roomCondition.totalPrice = conditionDetail.totalPrice;
          roomCondition.averageTotalPrice = this.calculateCurrency(conditionDetail.totalPrice);
          roomCondition.quantity = 0;
          roomCondition.isExpand = true;
          roomCondition.surcharges = conditionDetail.surcharges;

          roomCondition.benefits = conditionDetail.benefits;
          roomCondition.extraBed = conditionDetail.extraBed;
          roomCondition.displayExtraBed = this.translate.transform(`extra-bed-include`).replace('{text}', conditionDetail.extraBed);

          if (roomCondition.allotment > 0) {
            if (crossCondition) {
              roomCondition.selectAllotment = Array.from(Array(1 + roomCondition.allotment.valueOf()).keys());
            } else {
              roomCondition.selectAllotment = [0, searchForm.guests.length];
            }
          } else {
            roomCondition.selectAllotment = [];
          }

          roomCondition.lastFiveRoom = this.buildLastFiveRoomDescription(optionDetail.allotment);
          roomCondition.nonRefundableDescription = conditionDetail.cancellationPolicies && conditionDetail.cancellationPolicies.length > 0 ? ''
            : this.translate.transform(`product-detail-room-cancellation-non-refundable`);
          if (!roomCondition.nonRefundableDescription) {
            roomCondition.cancellationDescription = this.calculateCancellation(conditionDetail.cancellationPolicies);
            roomCondition.payOn = conditionDetail.payOn;
            roomCondition.paylaterDescription = this.calculatePaylater(conditionDetail.payOn);
            roomCondition.lastDayFreeCanllation = this.calculateLastDayFreeCancellation(conditionDetail.cancellationPolicies);
          }

          // check budget limit
          if (searchForm && searchForm.purpose === PurposeType.work && !isAllowBookForTraveller) {
            if (travelPolicyBudget && travelPolicyBudget > 0) {
              roomCondition.isOverLimit = +conditionDetail.netPrice > travelPolicyBudget;
              if (!!roomCondition.isOverLimit && allowMultiPayment) {
                roomCondition.overPrice = (+conditionDetail.netPrice) - travelPolicyBudget;
              }
            }
          }
          if (conditionDetail.promotion) {
            roomCondition.promotion = conditionDetail.promotion;
          }
          return roomCondition;
        }
      )
    ).reduce((first, second) => first.concat(second))
      .map((item, index) => {
        if (index === 0) {
          item.isExpand = true;
        }
        return item;
      });

    return roomConditionResult;
  }

  calculateCurrency(price: string): string {
    return (+price) > 0 ? this.utilities.insertCurrencySymbol(+price) : '';
  }

  calculatePaylater(payOn: string = ''): string {
    if (payOn === '') {
      return '';
    }
    const formatDate = this.appConfigService.dateAPIFormat;
    const minimumPaylaterDate = moment(payOn, formatDate);
    return this.buildPaylaterDescription(minimumPaylaterDate.format(formatDate));
  }

  buildPaylaterDescription(date: String): string {
    let currentLanguage = this.appConfigService.getLanguage();
    moment.locale(currentLanguage);

    let currentDate = moment(date.valueOf(), this.appConfigService.dateAPIFormat);
    if (!currentDate.isValid()) {
      return '';
    }

    let dateString = '';
    switch (currentLanguage) {
      case Language.th:
        dateString = this.utilities.convertYearToBuddhist(currentDate.format(this.appConfigService.dateCancellationPolicyFormat));
        break;
      case Language.en:
        dateString = currentDate.format(this.appConfigService.dateCancellationPolicyFormat);
    }

    return dateString ? this.translate.transform(`product-detail-room-paylater-description`).replace(/{.*}/gi, dateString) : dateString;

  }

  calculateCancellation(cancellations: CancellationPolicy[]): string[] {
    if (cancellations && cancellations.length > 0) {
      return cancellations
        .sort(this.sortCancellation.bind(this))
        .map(cancellation => this.buildCancellationDescription(cancellation).trim())
        .filter(cancellation => cancellation);
    }
    return [this.buildCancellationDescription(null)];
  }

  buildCancellationDescription(cancellation: CancellationPolicy): string {
    let currentLanguage = this.appConfigService.getLanguage(),
      dateString = '';
    moment.locale(currentLanguage);

    if (!cancellation) {
      return this.translate.transform(`product-detail-room-cancellation-non-refundable`);
    }

    dateString = moment(cancellation.from.valueOf(), this.appConfigService.dateAPIFormat).format(this.appConfigService.dateCancellationPolicyFormat);
    dateString = currentLanguage === `th` ? this.utilities.convertYearToBuddhist(dateString) : dateString;

    switch (true) {
      case cancellation.amount && cancellation.amount > 0:
        return this.translate.transform(`product-detail-room-cancellation-charge`)
          .replace(/{date}/gi, dateString)
          .replace(/{currency}/gi, DefaultValue.CURRENCY.currencyCode)
          .replace(/{amount}/gi, this.utilities.insertCurrencySymbol(cancellation.amount));
      default:
        return ``;
    }
  }

  buildLastFiveRoomDescription(roomRemain: number): string {
    return roomRemain && roomRemain <= 5 ? this.translate.transform(`product-detail-room-last-five`).replace(/{room}/gi, roomRemain) : '';
  }

  calculateLastDayFreeCancellation(cancellations: CancellationPolicy[]): string {
    if (cancellations && cancellations.length > 0) {
      const currentLanguage = this.appConfigService.getLanguage();
      moment.locale(currentLanguage);

      const nearestDateString = cancellations
        .filter(cancellation => cancellation.from)
        .sort(this.sortCancellation.bind(this))[0].from;
      const nearestDate = moment(nearestDateString, this.appConfigService.dateAPIFormat).add(1, 'days');
      if (!nearestDate.isAfter(moment(moment().format(this.appConfigService.dateAPIFormat), this.appConfigService.dateAPIFormat))) {
        return ``;
      }
      let dateString = nearestDate.format(this.appConfigService.dateCancellationPolicyFormat);
      dateString = currentLanguage === `th` ? this.utilities.convertYearToBuddhist(dateString) : dateString;
      return this.translate.transform(`product-detail-room-cancellation-free`).replace(/{date}/gi, dateString);
    }
    return ``;
  }

  sortCancellation(cancellation1, cancellation2) {
    const diffDate = moment(cancellation1.from, this.appConfigService.dateAPIFormat)
      .diff(moment(cancellation2.from, this.appConfigService.dateAPIFormat), 'days');
    if (diffDate < 0) {
      return -1;
    }
    if (diffDate > 0) {
      return 1;
    }
    return 0;
  }

  triggerExpandCondition(roomConditions: RoomConditionDto[], index: Number): RoomConditionDto[] {
    for (let i in roomConditions) {
      if (+i === index.valueOf()) {
        roomConditions[i].isExpand = !roomConditions[index.valueOf()].isExpand;
      }
    }
    return roomConditions;
  }

  formatDisplayTitle(title: String): string {
    return title ? title.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()) : ``;
  }

  calculateAllotment(allotment: number, searchForm: SearchFormModel, currentUser: UserModel): number {
    let maxAllot = this.maxAllotment;
    if (currentUser && currentUser.features && currentUser.features.length > 0 && searchForm.purpose === `work`) {
      const limitRoomFeatures = currentUser.features.find(feature => (feature.feature === FeatureType.ALLOW_LIMIT_ROOM && feature.allow));

      if (limitRoomFeatures) {
        maxAllot = limitRoomFeatures.data ? limitRoomFeatures.data.quantity : 1;
      }
    }

    return allotment > maxAllot ? maxAllot : allotment;
  }

  selectOnlyCurrentRoom(roomConditions: RoomConditionDto[], index: Number, searchForm: SearchFormModel, currentUser: UserModel, crossCondition: boolean): RoomConditionDto[] {
    const limitRoom = currentUser.features.find(feature => (feature.feature === FeatureType.ALLOW_LIMIT_ROOM && feature.allow));
    if (searchForm && searchForm.purpose === `work` && limitRoom || !crossCondition) {
      const roomAmount = limitRoom && limitRoom.data ? limitRoom.data.quantity : 1;
      let sum = 0;
      roomConditions.forEach(x => {
        sum += <number>x.quantity;
      });

      roomConditions.map((_room, roomIndex) => {
        if (index !== roomIndex && sum > roomAmount) {
          for (let x = 0; x < roomConditions.length; x++) {
            if (index !== x) {
              roomConditions[x].quantity = 0;
            }
          }
        }
      });
    }
    return roomConditions;
  }

  getProductNearBy(payload: ProductNearByPayload): Observable<ProductNearByModel[]> {
    const options = this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON);
    return this.actHttp
      .post(environment.endpoint.getProductNearBy, payload, options)
      .map(response => response.json().data);
  }

  private mapProductDetailsUrl(getProductDetailWithUrl: GetProductDetailWithUrlModel, destinationEncode: string, checkIn: string, checkOut: string): URLSearchParams {

    const urlWithParams = new URLSearchParams();
    urlWithParams.append("destination", `${destinationEncode}`);
    urlWithParams.append("purpose", `${getProductDetailWithUrl.purpose}`);
    urlWithParams.append("checkIn", `${checkIn}`);
    urlWithParams.append("checkOut", `${checkOut}`);
    urlWithParams.append("guests", `${this.utilitiesService.encodeQueryParamWrapper(getProductDetailWithUrl.guests)}`);
    urlWithParams.append("breakfast", `${getProductDetailWithUrl.breakfast}`);
    urlWithParams.append("overBudget", `${getProductDetailWithUrl.overBudget}`);
    urlWithParams.append("lang", `${this.appConfigService.getLanguage()}`);
    if (getProductDetailWithUrl.campaignId) {
      urlWithParams.append("campaignId", `${getProductDetailWithUrl.campaignId}`);
    }

    return urlWithParams;

  }

  getProductDetailsUrl(getProductDetailWithUrl: GetProductDetailWithUrlModel) {

    let destinationModel = new DestinationModel;
    destinationModel.id = String(getProductDetailWithUrl.id);
    destinationModel.slug = getProductDetailWithUrl.slug;
    destinationModel.suggestCat = getProductDetailWithUrl.suggestCat;
    destinationModel.title = getProductDetailWithUrl.title;

    const destinationEncode = this.utilitiesService.encodeQueryParamWrapper(destinationModel, useHotelDetailV2);
    let checkIn: string = getProductDetailWithUrl.checkInDate;
    let checkOut: string = getProductDetailWithUrl.checkOutDate;
    if (getProductDetailWithUrl.isReverseFormatDate) {
      checkIn = this.utilitiesService.reverseFormatDate(getProductDetailWithUrl.checkInDate);
      checkOut = this.utilitiesService.reverseFormatDate(getProductDetailWithUrl.checkOutDate);
    }

    const params = this.mapProductDetailsUrl(getProductDetailWithUrl, destinationEncode, checkIn, checkOut);
    const url = `hotel/detail/${getProductDetailWithUrl.slug}?${params}`;
    if (useHotelDetailV2) {
      return url.replace("hotel/detail/", `${redirectURIV2}/hotel/`);
    }
    return url;
  }

  transformProductToProductNearbyDTO(product: ProductListModel | ProductDetailModel | CheapestRoom,
    searchData: SearchFormModel, priceRange: PriceRange, netPrice: number = 0, radius: number = 15000): ProductNearByDTO {
    const productNearby = new ProductNearByDTO();
    !priceRange && (priceRange = new PriceRange(0, 0));
    if (product && searchData) {
      productNearby.langId = this.appConfigService.getLanguageId();
      productNearby.priceRange = priceRange;
      productNearby.rooms = searchData.guests;
      productNearby.radius = radius;
      switch (true) {
        case product instanceof ProductListModel:
          const productItem = <ProductListModel>product;
          productNearby.address = `${productItem.address} ${productItem.destinationTitle}`;
          productNearby.destinationId = +searchData.destination.id;
          productNearby.currencyId = productItem.currencyId;
          productNearby.latitude = productItem.latitude;
          productNearby.longitude = productItem.longitude;
          productNearby.productId = productItem.productId;
          productNearby.hotelStar = productItem.rating;
          productNearby.productTitle = productItem.productTitle;
          productNearby.netPrice = productItem.netPrice;
          productNearby.imageUrl = productItem.image;
          productNearby.slug = productItem.slug;
          productNearby.checkIn = searchData.checkInDate;
          productNearby.checkOut = searchData.checkOutDate;
          productNearby.reviewRating = productItem.reviewRating;
          break;
        case product instanceof ProductDetailModel:
          const productDetail = <ProductDetailModel>product;
          productNearby.address = `${productDetail.details.address}, ${productDetail.details.destinationTitle}, ${productDetail.details.countryTitle}`;
          productNearby.destinationId = productDetail.details.destinationId;
          productNearby.currencyId = +this.appConfigService.getCurrencyId();
          productNearby.latitude = productDetail.details.latitude;
          productNearby.longitude = productDetail.details.longitude;
          productNearby.productId = productDetail.details.productId;
          productNearby.hotelStar = productDetail.details.ratingPoint;
          productNearby.productTitle = productDetail.details.title;
          productNearby.slug = productDetail.details.slug;
          productNearby.netPrice = netPrice;
          productNearby.imageUrl = productDetail.images[0].thumbnail['1x'];
          productNearby.checkIn = this.utilitiesService.convertDateFormat(searchData.checkInDate, 'DD-MM-YYYY', 'YYYY-MM-DD', 'en');
          productNearby.checkOut = this.utilitiesService.convertDateFormat(searchData.checkOutDate, 'DD-MM-YYYY', 'YYYY-MM-DD', 'en');
          productNearby.reviewRating = productDetail.details.reviewRating;
          break;
        case product instanceof CheapestRoom:
          const cheapestRoom = <CheapestRoom>product;
          productNearby.address = cheapestRoom.productTitle;
          productNearby.destinationId = cheapestRoom.destinationId;
          productNearby.currencyId = +this.appConfigService.getCurrencyId();
          productNearby.latitude = cheapestRoom.latitude;
          productNearby.longitude = cheapestRoom.longitude;
          productNearby.productId = cheapestRoom.productId;
          productNearby.hotelStar = cheapestRoom.hotelStar;
          productNearby.productTitle = cheapestRoom.productTitle;
          productNearby.slug = cheapestRoom.slug;
          productNearby.netPrice = cheapestRoom.netPrice;
          productNearby.imageUrl = cheapestRoom.imageUrl;
          productNearby.checkIn = this.utilitiesService.convertDateFormat(searchData.checkInDate, 'DD-MM-YYYY', 'YYYY-MM-DD', 'en');
          productNearby.checkOut = this.utilitiesService.convertDateFormat(searchData.checkOutDate, 'DD-MM-YYYY', 'YYYY-MM-DD', 'en');
          productNearby.reviewRating = new ProductReviewModel();
          cheapestRoom.reviewRatingScore && (productNearby.reviewRating.totalScore = cheapestRoom.reviewRatingScore.toString());
      }
    }

    return productNearby;
  }

  calculateDistanceToKilometer(meter: number): string {
    if (meter < 10) {
      return (Math.round((meter / 1000) * 1000) / 1000).toString();
    } else if (meter < 100) {
      return (Math.round((meter / 1000) * 100) / 100).toString();
    } else {
      return (Math.round((meter / 1000) * 10) / 10).toString();
    }
  }

  setNewAllotLimit(key: number, list: RoomConditionDto[], index: number) {
    if (key !== undefined) {
      const selectRoomCode = list[index].roomCode;
      const fullAllotment = <number>list[index].allotment;

      let sum = 0;
      list.forEach(x => {
        if (x.roomCode === selectRoomCode) {
          sum += <number>x.quantity;
        }
      });

      const diff = fullAllotment - sum;

      for (let x = 0; x < list.length; x++) {
        if (list[x].roomCode === selectRoomCode) {
          if (list[x].quantity === 0) {
            list[x].selectAllotment = this.pushNumber(diff);
          } else {
            const cal = <number>list[x].quantity + diff;
            list[x].selectAllotment = this.pushNumber(cal);
          }
        }
      }
    }
  }

  pushNumber(length: number): Array<number> {
    const list = [];
    for (let i = 0; i <= length; i++) {
      list.push(i);
    }
    return list;
  }

  allowMultiPayment(currentUser: UserModel, isCreditTermsFeature: boolean = false, isCorporateFleetFeature: boolean = false) {
    const creditTermMulti = currentUser.features.filter(x =>
      (x.feature === FeatureType.ALLOW_CREDIT_TERMS && x.allow) ||
      (x.feature === FeatureType.ALLOW_MULTI_PAYMENT && x.allow)).length === 2;

    const corporateFleetMulti = currentUser.features.filter(x =>
      (x.feature === FeatureType.ALLOW_MULTI_PAYMENT_CORPORATE_FLEET && x.allow) ||
      (x.feature === FeatureType.ALLOW_CORPORATE_FLEET && x.allow)).length === 2;

    if (isCreditTermsFeature) {
      return creditTermMulti;
    } else if (isCorporateFleetFeature) {
      return corporateFleetMulti;
    } else {
      return creditTermMulti || corporateFleetMulti;
    }
  }

  calculateReviewRatingTitle(reviewRatingScore: number): string {
    if (reviewRatingScore >= 9) {
      return 'product-review-rating-exceptional';
    } else if (reviewRatingScore >= 8) {
      return 'product-review-rating-excellent';
    } else if (reviewRatingScore >= 7) {
      return 'product-review-rating-very-good';
    } else if (reviewRatingScore >= 0) {
      return 'product-review-rating-review-score';
    }
    return '';
  }

  transformSHADetail(displayLabels?: DisplayLabel[]): ShaModel {
    let shaDetail: ShaModel;
    if (displayLabels && displayLabels.length > 0) {
      const displaySHA = displayLabels.find(dl => dl.name.toLowerCase() === ProductDisplayLabel.SHA.toLowerCase());
      const displaySHAplus = displayLabels.find(dl => dl.name.toLowerCase() === ProductDisplayLabel.SHA_PLUS.toLowerCase());
      if (!!displaySHA || !!displaySHAplus) {
        const certificateId = (displaySHA && displaySHA.value) || (displaySHAplus && displaySHAplus.value);
        shaDetail = new ShaModel(!!displaySHAplus, certificateId);
      }
    }
    return shaDetail;
  }

  transformBadgeDetail(displaySanitation: boolean, displayLabels: DisplayLabel[]): BadgeModel {
    const badgeDetail = new BadgeModel();
    const lang = this.appConfigService.getLanguage();
    badgeDetail.displaySanitation = displaySanitation;
    if (displayLabels && displayLabels.length > 0) {
      const yearOfBuild = displayLabels.find(dl => dl.name.toLowerCase() === ProductDisplayLabel.YEAR_OF_BUILD.toLowerCase());
      if (yearOfBuild) {
        badgeDetail.displayYearOfBuild = lang === Language.th ? this.utilitiesService.toBEraYear(yearOfBuild.value).toString() : yearOfBuild.value;
      }

      const yearOfRenovated = displayLabels.find(dl => dl.name.toLowerCase() === ProductDisplayLabel.YEAR_OF_RENOVATED.toLowerCase());
      if (yearOfRenovated) {
        badgeDetail.displayYearOfRenovated = lang === Language.th ? this.utilitiesService.toBEraYear(yearOfRenovated.value).toString() : yearOfRenovated.value;
      }

      const securityStandard = displayLabels.find(dl => dl.name.toLowerCase() === ProductDisplayLabel.SECURITY_STANDARD.toLowerCase());
      if (securityStandard) {
        badgeDetail.displaySecurityStandard = securityStandard.value === "Yes";
      }
    }
    return badgeDetail;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/products/product.service.ts